import React from "react";
const CircleCheck = ({
  width = "20",
  height = "20",
  stroke = "#6C747A",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      {...props}
    >
      <circle cx="8" cy="8.5" r="6.5" stroke={stroke} />
    </svg>
  );
};
export default CircleCheck;
